import { extend } from 'underscore';
import {
  paginationStyle,
  getColumnSolidBorderStyle,
} from '@bingads-webui-campaign-react/common-styles';
import { pagePaddingStyle } from '@bingads-webui-campaign-react/page-padding-style';

const iconFontFamily = 'MsAds MDL2 Assets';

export const getDimensionsPageStyle = (_, { palette = {} }) => ({
  gridCustomStyles: getColumnSolidBorderStyle(0, 2),
  topGridPanelCustomStyles: paginationStyle({ palette, iconFontFamily }),
  '@global': extend({
    '.dimensions-table td.text-left': {
      wordWrap: 'break-word',
      wordBreak: 'break-word',
    },
    ...pagePaddingStyle(),
  }),
  accountSelectorPopover: {
    padding: 0,
    margin: 0,
    height: 0,
    width: 0,
    border: 0,
    '& .arrow': {
      display: 'none',
    },

    '& .hidden': {
      display: 'none',
    },

    '& .popover-content': {
      fontSize: 14,
      float: 'right',
      height: 0,
      padding: 0,
      margin: 0,

      '& .account-selector-popup': {
        height: 538,
      },
    },
  },

  customToolbarItem: {
    flex: '0 0 auto',
    border: 'none',
    height: 56,
    fontSize: 14,
    fontWeight: 'unset !important',
    paddingLeft: 8,
    paddingRight: 8,

    '& .text': {
      verticalAlign: 'text-bottom',
    },

    '& .caret': {
      height: 20,
      paddingLeft: 4,
      '&:before': {
        content: '"\\E70D"',
        fontFamily: iconFontFamily,
      },
    },
  },

  downloadIcon: {
    margin: '0 4px',
    color: palette.themeDarkAlt,

    '&:before': {
      content: '"\\E896"',
      fontFamily: iconFontFamily,
    },
  },
});
